import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { IPD_COLORS } from './ipdColors';

export default function IpdButton({
  children, variant = 'contained', tone = 'teal',
  loading, startIcon, onClick, disabled, size = 'medium', sx = {}, type, form, title,
}) {
  const colorMap = {
    teal:    IPD_COLORS.primary,
    mint:    IPD_COLORS.success.text,
    amber:   IPD_COLORS.warning.text,
    red:     IPD_COLORS.error.text,
    ghost:   'transparent',
  };
  const color = colorMap[tone] || IPD_COLORS.primary;

  const variantSx = variant === 'contained'
    ? {
        background: color,
        color: tone === 'amber' ? '#000' : IPD_COLORS.white,
        boxShadow: IPD_COLORS.shadow.button,
        '&:hover': {
          background: tone === 'teal' ? IPD_COLORS.primaryDark
            : tone === 'mint' ? IPD_COLORS.success.text
            : color,
          boxShadow: IPD_COLORS.shadow.buttonHover,
        },
        '&:disabled': { background: `${color}50`, color: '#ffffff90' },
      }
    : {
        color: IPD_COLORS.primary,
        borderColor: IPD_COLORS.border,
        backgroundColor: IPD_COLORS.cardBg,
        '&:hover': {
          backgroundColor: IPD_COLORS.selectedBg,
          borderColor: IPD_COLORS.primary,
        },
      };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled || loading}
      type={type ?? 'button'}
      form={form}
      title={title}
      startIcon={loading ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : startIcon}
      sx={{ textTransform: 'none', fontWeight: 600, borderRadius: '10px', ...variantSx, ...sx }}
    >
      {children}
    </Button>
  );
}
